(() => {
  const initialized = new WeakSet();
  const initializedBadges = new WeakSet();
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  function findVisibleMediaImage(root) {
    const candidates = [...root.querySelectorAll('.product__media-item img, .product__media img')];
    return candidates.find((img) => {
      const rect = img.getBoundingClientRect();
      return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.top < window.innerHeight;
    }) || candidates[0];
  }

  function animateToCart(root) {
    if (reduceMotion) return;
    const source = findVisibleMediaImage(root);
    const cart = document.querySelector('.header__icon--cart, a[href*="/cart"]');
    if (!source || !cart) return;

    const sourceRect = source.getBoundingClientRect();
    const cartRect = cart.getBoundingClientRect();
    if (!sourceRect.width || !cartRect.width) return;

    const clone = document.createElement('img');
    clone.className = 'loot-fly-image';
    clone.alt = '';
    clone.src = source.currentSrc || source.src;
    clone.style.left = `${sourceRect.left + sourceRect.width / 2 - 32}px`;
    clone.style.top = `${sourceRect.top + sourceRect.height / 2 - 32}px`;
    document.body.appendChild(clone);

    requestAnimationFrame(() => {
      const dx = cartRect.left + cartRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
      const dy = cartRect.top + cartRect.height / 2 - (sourceRect.top + sourceRect.height / 2);
      clone.style.transform = `translate(${dx}px, ${dy}px) scale(.2) rotate(8deg)`;
      clone.style.opacity = '0';
    });

    window.setTimeout(() => clone.remove(), 760);
  }

  function updateStickyFromSource(root, sourceRoot = root) {
    const sectionId = root.dataset.section;
    const sticky = root.querySelector(`#LootMobileBuybar-${CSS.escape(sectionId)}`);
    if (!sticky) return;

    const stickyPrice = sticky.querySelector('.loot-mobile-buybar__price');
    const sourcePrice = sourceRoot.querySelector(`#price-${CSS.escape(sectionId)} .price-item--sale, #price-${CSS.escape(sectionId)} .price-item--regular, #price-${CSS.escape(sectionId)} .price-item`);
    if (stickyPrice && sourcePrice?.textContent?.trim()) stickyPrice.textContent = sourcePrice.textContent.trim();

    const originalSubmit = root.querySelector(`#ProductSubmitButton-${CSS.escape(sectionId)}`);
    const stickySubmit = sticky.querySelector('[data-loot-sticky-submit]');
    if (!stickySubmit || !originalSubmit) return;

    const disabled = originalSubmit.disabled || originalSubmit.getAttribute('aria-disabled') === 'true';
    stickySubmit.disabled = disabled;
    const originalText = originalSubmit.querySelector('span')?.textContent?.trim();
    stickySubmit.textContent = disabled ? 'Hepsi satıldı!' : (originalText || 'Lootla');
  }

  function initializeSticky(root) {
    const sticky = root.querySelector('.loot-mobile-buybar');
    const originalSubmit = root.querySelector('.product-form__submit');
    if (!sticky || !originalSubmit) return;

    const stickySubmit = sticky.querySelector('[data-loot-sticky-submit]');
    stickySubmit?.addEventListener('click', () => {
      if (stickySubmit.disabled) return;
      stickySubmit.classList.add('is-loot-energized');
      window.setTimeout(() => stickySubmit.classList.remove('is-loot-energized'), 600);
      originalSubmit.click();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', shouldShow);
        document.body.classList.toggle('loot-buybar-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }, { threshold: .15 });
      observer.observe(originalSubmit);
    } else {
      const onScroll = () => {
        const rect = originalSubmit.getBoundingClientRect();
        const shouldShow = rect.bottom < 0;
        sticky.classList.toggle('is-visible', shouldShow);
        document.body.classList.toggle('loot-buybar-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    updateStickyFromSource(root);
  }

  function initializeAddFeedback(root) {
    const submit = root.querySelector('.product-form__submit');
    if (!submit) return;

    submit.addEventListener('click', () => {
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      submit.classList.add('is-loot-energized');
      window.setTimeout(() => submit.classList.remove('is-loot-energized'), 620);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, ({ data }) => {
        if (data?.source !== 'product-form' || !root.isConnected) return;
        const label = submit.querySelector('span');
        const previous = label?.textContent;
        animateToCart(root);
        submit.classList.add('is-loot-success');
        if (label) label.textContent = 'Loot sepete düştü!';
        window.setTimeout(() => {
          submit.classList.remove('is-loot-success');
          if (label && previous) label.textContent = previous;
        }, 1300);
      });
    }
  }

  function initializeReviewJump(root) {
    root.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      if (initializedBadges.has(badge)) return;
      initializedBadges.add(badge);
      badge.style.cursor = 'pointer';
      badge.addEventListener('click', (event) => {
        const target = document.querySelector('.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initialize(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    initializeSticky(root);
    initializeAddFeedback(root);
    initializeReviewJump(root);
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll?.('product-info.loot-product-page').forEach(initialize);
  }

  document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  document.addEventListener('product-info:loaded', (event) => initialize(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const root = document.querySelector(`product-info[data-section="${CSS.escape(String(data.sectionId))}"]`);
      if (!root) return;
      updateStickyFromSource(root, data.html || root);
    });
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('product-info.loot-product-page')) {
          initialize(node);
        } else {
          initializeAll(node);
          const productRoot = node.closest?.('product-info.loot-product-page');
          if (productRoot) initializeReviewJump(productRoot);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
